<mkp-product-display-read-only
  [showPlatformSwitch]="showPlatformSwitch"
  [showStickyHeader]="showStickyHeader"
/>
<ng-content />
